// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"02708b34","391":"849d208d","646":"f2f99335","787":"90c5de79","997":"4e0ea101"}[chunkId] + ".chunk.js";
};